import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import WithRender from "./highlight.html";

@WithRender
@Component
export default class HighlightComponent extends Vue {
    @Prop()
    public select!: string;

    @Prop()
    public text!: string;

    public get highlighted() {
        if (!this.select || !this.text) {
            return this.text;
        }

        let s = this.select.trim();
        s = s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const check = new RegExp(s, "ig");

        return this.text.toString().replace(check, (matchedText: string) => {
            return ("<span class='has-background-sunrise has-text-black'>" + matchedText + "</span>");
        });
    }
}
